// extracted by mini-css-extract-plugin
module.exports = {"channel":"_2kJ8B"};